import { memo } from 'react';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { TooltipPlacement } from 'antd/es/tooltip';

import styles from './ExplainedLabel.module.css';

interface ExplainedLabelProps {
  label: string;
  explanation: string;
  placement?: TooltipPlacement;
  isMobileView?: boolean;
}

function ExplainedLabel({ label, explanation, placement, isMobileView }: ExplainedLabelProps) {
  return (
    <>
      {isMobileView ? (
        <>
          <div>{label}</div>
          <div className={styles.explanation}>{explanation}</div>
        </>
      ) : (
        <>
          <span className={styles['menu-label']}>{label}</span>
          <Tooltip title={explanation} placement={placement}>
            <QuestionCircleOutlined />
          </Tooltip>
        </>
      )}
    </>
  );
}

export default memo(ExplainedLabel);
